import Typography from 'components/generics/texts/Typography';
import classes from './index.module.scss';
import { MAINTENANCE_TICKET } from '../../utils';
import CheckMark from 'public/assets/icons/checkmark.svg';

const MaintenanceExplanation = () => {
  return (
    <div className={classes.container}>
      {MAINTENANCE_TICKET.map((row, index) => (
        <div
          key={index}
          className={classes.rowContainer}
        >
          <div className={classes.icon}>
            <CheckMark
              fill={'var(--color-white)'}
              style={{ width: '20px', height: '16px' }}
            />
          </div>
          <div className={classes.textContainer}>
            <Typography className={classes.title}>{row.title}</Typography>
            <Typography className={classes.subtitle}>{row.body}</Typography>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MaintenanceExplanation;
